import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import en from './locales/en.json'
import he from './locales/he.json'
import ar from './locales/ar.json'
import de from './locales/de.json'
import fr from './locales/fr.json'

const resources = {
  en: { translation: en },
  he: { translation: he },
  ar: { translation: ar },
  de: { translation: de },
  fr: { translation: fr },
}

// Helper function to get language from the language store
const getStoredLanguage = (): string => {
  try {
    const storedLanguage = localStorage.getItem('language-storage')
    if (storedLanguage) {
      const parsed = JSON.parse(storedLanguage)
      if (parsed?.state?.language) {
        return parsed.state.language
      }
    }
  } catch (e) {
    // Ignore parsing errors
  }
  
  // Fallback to browser language detection
  const browserLanguage = navigator.language.split('-')[0]
  const supportedLanguages = ['en', 'he', 'ar', 'de', 'fr']
  
  return supportedLanguages.includes(browserLanguage) ? browserLanguage : 'en'
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: getStoredLanguage(),
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false,
    },
  })

export default i18n 